/**
 * icon:菜单项图标
 * roles:标明当前菜单项在何种角色下可以显示，如果不写此选项，表示该菜单项完全公开，在任何角色下都显示
 */
const menuList = [
  {
    title: "首页",
    path: "/dashboard",
    icon: "home",
    roles:["admin","editor","guest"]
  },
  {
    title: "图片上传",
    path: "/upload",
    icon: "table",
    roles:["admin","editor"]
  },
  {
    title: "量角用户",
    path: "/wechat-user",
    icon: "team",
    roles:["admin","editor"]
  },
	{
    title: "意见反馈",
    path: "/feedback",
    icon: "table",
    roles:["admin","editor"]
  },
  {
    title: "账号管理",
    path: "/account",
    icon: "user",
    roles:["admin"]
  }
];
export default menuList;
